import cx from "classnames";
import {
  MDBAnimation,
  MDBCard,
  MDBCardBody,
  MDBCol,
  MDBContainer,
  MDBRow
} from "mdbreact";
import React from "react";
import LazyLoad from "react-lazyload";
import facebook from "~/assets/img/desktop/icon/facebook.svg";
import qrmed from "~/assets/img/desktop/icon/qrmed.jpg";
import support from "~/assets/img/desktop/icon/support.svg";
import TagName from "~/components/common/atoms/TagName";
import partnerId from "~/utils/partner";
import styles from "./style.module.scss";
const QRCode = require("qrcode.react");

const SupportMedPro = props => {
  return (
    <MDBAnimation
      reveal="true"
      type="fadeIn"
      className={cx(styles.supportMedPro, styles["supportMedPro_" + partnerId])}
    >
      <div className={styles.supportMedPro_inner}>
        <MDBContainer>
          <MDBRow>
            <MDBCol size="12">
              <div>
                <TagName element="span" className={["title_section"]}>
                  Hỗ trợ
                </TagName>
              </div>
              <TagName
                element="h2"
                className={["sub_title_section", "title_featureMedpro"]}
              >
                Các hình thức hỗ trợ
              </TagName>
            </MDBCol>
          </MDBRow>
          <MDBRow>
            <MDBCol size={6} md="3">
              <MDBCard className={styles.cardSupport}>
                <LazyLoad height={100}>
                  <img src={support} alt="Hỗ trợ medpro" />
                </LazyLoad>
                <MDBCardBody className={styles.new_body}>
                  <h3 className={styles.wrapper_title}>Hỗ trợ đặt khám</h3>
                  <div className={styles.wrapper_title}>
                    <a href="tel:19002115" title="19002115">
                      1900-2115
                    </a>
                  </div>
                </MDBCardBody>
              </MDBCard>
            </MDBCol>
            <MDBCol size={6} md="3">
              <MDBCard className={styles.cardSupport}>
                <a
                  href="https://www.facebook.com/www.medpro.vn"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <LazyLoad height={100}>
                    <img src={facebook} alt="Facebook" />
                  </LazyLoad>
                </a>
                <MDBCardBody className={styles.new_body}>
                  <h3 className={styles.wrapper_title}>Fanpage Facebook</h3>
                  <div className={styles.wrapper_title}>
                    <a
                      href="https://www.facebook.com/www.medpro.vn"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Bấm vào đây
                    </a>
                  </div>
                </MDBCardBody>
              </MDBCard>
            </MDBCol>
            <MDBCol size={6} md="3">
              <MDBCard className={styles.cardSupport}>
                <a
                  href="https://zalo.me/4018184502979486994"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <LazyLoad height={100}>
                    <img src={qrmed} alt="QR Medpro" />
                  </LazyLoad>
                </a>

                <MDBCardBody className={styles.new_body}>
                  <h3 className={styles.wrapper_title}>Hỗ trợ ZALO</h3>
                  <div className={styles.wrapper_title}>
                    <a
                      href="https://zalo.me/4018184502979486994"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Bấm vào đây
                    </a>
                  </div>
                </MDBCardBody>
              </MDBCard>
            </MDBCol>
            <MDBCol size={6} md="3">
              <MDBCard className={styles.cardSupport}>
                <a
                  href="https://m.me/www.medpro.vn"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <LazyLoad height={100}>
                    <QRCode
                      fgColor="#000000"
                      size={80}
                      value="https://m.me/www.medpro.vn"
                    />
                  </LazyLoad>
                </a>
                <MDBCardBody className={styles.new_body}>
                  <h3 className={styles.wrapper_title}>Chat Facebook</h3>
                  <div className={styles.wrapper_title}>
                    <a
                      href="https://m.me/www.medpro.vn"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Bấm vào đây
                    </a>
                  </div>
                </MDBCardBody>
              </MDBCard>
            </MDBCol>
          </MDBRow>
        </MDBContainer>
      </div>
    </MDBAnimation>
  );
};

export default SupportMedPro;
